import { ExamStatus, ExamTypes } from "../types/enums";

export const isMultiAnswersExam = (type) => {
	return [ExamTypes.SIMULATION, ExamTypes.LEARNING].includes(type);
};

export const isFinishedExam = (status) => {
	return status === ExamStatus.FINISHED;
};
